import {useCallback, useEffect, useState} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {connect, setAddress, setChainId} from '../redux/wallet.slice';
import {getChainData} from '../sdk';
import walletService, {Connector, web3Modal} from '../services/wallet.service';
import './app.sass';
import Layout from './components/layout/layout';
import {useAppDispatch} from './hooks';
import Pages from './pages';

function App() {
  const [inited, setInited] = useState(false);
  const dispatch = useAppDispatch();
  const init = useCallback(() => {
    if (web3Modal.cachedProvider) {
      (async () => {
        await dispatch(connect(web3Modal.cachedProvider as Connector));
        setInited(true);
      })();
    } else {
      setInited(true);
    }
  }, [dispatch]);

  useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', () => {
        window.location.reload();
      });
    }
  }, []);

  useEffect(() => {
    walletService.initHandlers(
      async accounts => {
        dispatch(setAddress(accounts[0]));
      },
      async chainId => {
        const chainData = getChainData(chainId);
        if (!chainData || chainData instanceof Error) {
          setChainId(0);
          return;
        }
        dispatch(setChainId(chainId));
        init();
      },
      async () => {
        dispatch(setAddress(''));
        dispatch(setChainId(0));
      },
    );
    init();
  }, [dispatch, init]);

  return (
    <div className="app">
      <Router basename="/form">
        {inited && (
          <Layout>
            <Pages />
          </Layout>
        )}
      </Router>
    </div>
  );
}

export default App;
